import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import HomePage from '@/routes/HomePage';
import GalleryPage from '@/routes/GalleryPage';
import UploadPage from '@/routes/UploadPage';
import DebugPage from '@/routes/DebugPage';
import AdminLoginPage from '@/routes/AdminLoginPage';
import ModerationPage from '@/routes/ModerationPage';
import UsersPage from '@/routes/UsersPage';
import { useVisitor } from '@/hooks/useVisitor';
import { useInvitationGate } from '@/hooks/useInvitationGate';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import { AdminBar } from '@/components/admin/AdminBar';
import { GatedScreen } from '@/components/gate/GatedScreen';

const qc = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

function AppShell() {
  const location = useLocation();
  const { loading, authorized, tryAuthorize } = useInvitationGate();
  const { role } = useAdminAuth();

  // Admin are acces intotdeauna (poate modera fara sa scaneze QR)
  // /admin/login e accesibil fara gate (ca sa te poti autentifica)
  const isAdminPath = location.pathname.startsWith('/admin');
  const isExempt = !!role || isAdminPath;

  // AdminBar nu apare pe paginile de admin (au propriul chrome)
  const showBar = !isAdminPath && (authorized || isExempt);

  if (loading) {
    return (
      <main className="flex min-h-screen items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-border border-t-accent" />
      </main>
    );
  }

  // Daca nu e autorizat si nu e exempt, aratam GatedScreen
  if (!authorized && !isExempt) {
    return <GatedScreen onAuthorize={tryAuthorize} />;
  }

  return (
    <>
      {showBar && <AdminBar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/debug" element={<DebugPage />} />
        <Route path="/admin" element={<AdminLoginPage />} />
        <Route path="/admin/moderate" element={<ModerationPage />} />
        <Route path="/admin/users" element={<UsersPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </>
  );
}

export default function App() {
  useVisitor();

  return (
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </QueryClientProvider>
  );
}